import { trimQueryName } from './helper'
import { DEFAULT_ENGINE } from '../src/utils/search-engines'
export const appState = {
  state: () => ({
    showResultsSection: true,
    showResultsComponent: true,
    showAIComponent: false,
    resultsContainerWidth: 300,
    snackbarText: null,
    showSnackbar: false,
    isShowingSpinner: false,
    updateTargetEngine: false,
    targetSource: DEFAULT_ENGINE,
    showQueryProblemMessages: false,
    showQueryTranslations: false
  }),
  getters: {
    getTrimmedQueryName: () => (queryName) => {
      return trimQueryName(queryName)
    },
    getResultsContainerRightControlsPosition (state) {
      return state.showResultsComponent ? state.resultsContainerWidth - 12 + 'px' : '66px'
    },
    getUpdateTargetEngine (state) { return state.updateTargetEngine },
    getTargetSource (state) { return state.targetSource },
    getShowQueryProblemMessages (state) { return state.showQueryProblemMessages },
    getShowQueryTranslations (state) { return state.showQueryTranslations }
  },
  mutations: {
    setShowResultsSection (state, showResultsSection) {
      state.showResultsSection = showResultsSection
    },
    toggleShowResultsSection (state) {
      state.showResultsSection = !state.showResultsSection
    },
    showResultsComponent (state) {
      state.showResultsComponent = true
      state.showAIComponent = false
    },
    showAiComponent (state) {
      state.showAIComponent = true
      state.showResultsComponent = false
      state.showQueryProblemMessages = false
      state.showQueryTranslations = false
    },
    setResultsContainerWidth (state, resultsContainerWidth) {
      state.resultsContainerWidth = resultsContainerWidth
    },
    setSnackbarText (state, snackbarText) {
      state.snackbarText = snackbarText
      state.showSnackbar = true
    },
    setShowSnackbar (state, showSnackbar) {
      state.showSnackbar = showSnackbar
    },
    setIsShowingSpinner (state, isShowingSpinner) {
      state.isShowingSpinner = isShowingSpinner
    },
    setUpdateTargetEngine (state, newValue) {
      state.updateTargetEngine = newValue
    },
    setTargetSource (state, newEngine) {
      state.targetSource = newEngine
    },
    setHandleProblemsClick (state) {
      state.showQueryProblemMessages = !state.showQueryProblemMessages
      state.showQueryTranslations = false
    },
    setHandleQueryTranslationsClick (state) {
      state.showQueryTranslations = !state.showQueryTranslations
      state.showQueryProblemMessages = false
    }
  },
  actions: {
    handleSearchAIClick ({commit, state}) {
      if (!state.showResultsSection) {
        commit('showResultsSection')
        commit('showAiComponent')
      } else {
        if (state.showResultsComponent) {
          commit('showAiComponent')
        } else {
          commit('showResultsComponent')
        }
      }
    },
    handleShowResultsFromAi ({commit}) {
      commit('showResultsComponent')
      commit('setTargetSource', DEFAULT_ENGINE)
      commit('setUpdateTargetEngine', true)
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./store/appState.js
// module id = null
// module chunks = 